export default "__VITE_ASSET__7905de37__"